import { Tabs as MuiTabs } from '@material-ui/core'
import Tab from './Tab'

const HorizontalTabs = MuiTabs
HorizontalTabs.Tab = Tab

export default HorizontalTabs
